import { render } from "./AtLogoCard.vue?vue&type=template&id=45525072&scoped=true&ts=true"
import script from "./AtLogoCard.vue?vue&type=script&lang=ts"
export * from "./AtLogoCard.vue?vue&type=script&lang=ts"

import "./AtLogoCard.vue?vue&type=style&index=0&id=45525072&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45525072"]])

export default __exports__